export default __webpack_public_path__ + "../staticImages/hawlogo23-symbol-black.svg";